import $ from 'jquery';
import {Widget, AgendaWidget, SpeakerWidget, SponsorWidget, SubscribeWidget, CalendarWidget} from './widgets';
import {Popup, SessionPopup, MoreInfoPopup, SponsorPopup, LinkedSessionPopup} from './popups';
import {
    BaseException, AbstractException, InvalidArgumentException,
    ClassDoesNotExistException
} from './Exceptions';

/**
 * Registry class implements a Service Locator pattern. This class acts as a Registry as well as a Factory.
 * Classes are registered in the registry by using Registry.register.
 * Instances are created by using Registry.create("ClassName", args);
 */
export default class Registry {

    static initClass() {
        this.ereg = false;
        this.language = "eng";
        Registry.register("BaseException", BaseException);
        Registry.register("AbstractException", AbstractException);
        Registry.register("InvalidArgumentException", InvalidArgumentException);
        Registry.register("ClassDoesNotExistException", ClassDoesNotExistException);
        Registry.register("Widget", Widget);
        Registry.register("AgendaWidget", AgendaWidget);
        Registry.register("SpeakerWidget", SpeakerWidget);
        Registry.register("SubscribeWidget", SubscribeWidget);
        Registry.register("SponsorWidget", SponsorWidget);
        Registry.register("CalendarWidget", CalendarWidget);
        Popup.initClass();
        Registry.register("Popup", Popup);
        Registry.register("SessionPopup", SessionPopup);
        Registry.register("LinkedSessionPopup", LinkedSessionPopup);
        Registry.register("MoreInfoPopup", MoreInfoPopup);
        Registry.register("SponsorPopup", SponsorPopup);
    }

    static d(test){
        if (Registry.debug) {
            return window.console.debug(test);
        }
    }

    static register(type, obj){
        Registry.d(`Registry.register ${type}`);
        return top.__etouches.classes[type] = obj;
    }

    static create(type, args){
        Registry.d(`Registry.create ${type}`);
        if (typeof top !== "undefined" && top && top.__etouches.classes[type] !== undefined) {
            if (top.__etouches.objs[type] === undefined) {
                top.__etouches.objs[type] = [];
            }
            const obj = new top.__etouches.classes[type](args);
            top.__etouches.objs[type].push(obj);
            return obj;
        } else {
            throw new ClassDoesNotExistException(`Class ${type} does not exist`);
        }
    }

    static notify(id, key, val) {
        Registry.d("Registry.notify");
        let types = Object.keys(top.__etouches.objs);
        for(let i = 0; i < types.length; i++) {
            let objectList = top.__etouches.objs[types[i]];
            let broke = false;
            for(let j = 0; j < objectList.length; j++) {
                if (objectList[j].containerid === id) {
                    objectList[j].notify(key, val);
                    broke = true;
                    break;
                }
            }
            if (broke) break;
        }
    }

    static notifyType(type, key, val) {
        Registry.d("Registry.notifyType");
        for(let i = 0; i < top.__etouches.objs[type].length; i++) {
            top.__etouches.objs[type][i].notify(key, val);
        }
    }

    static autoAdjust() {
        Registry.d("Registry.autoAdjust");
        if(typeof top === "undefined" || !top || typeof(top.__etouches) === "undefined") return false;

        if (top.__etouches.objs !== "undefined") {
            if (top.__etouches.objs.hasOwnProperty('Widget')) {
                for (let y of Array.from(top.__etouches.objs["Widget"])) {
                    let { containerid } = y;
                    let height = $(`iframe[data-containerid='${containerid}']`).contents().find(".etouches-bootstrap").height();
                    $(`iframe[data-containerid='${containerid}']`).css({height: height});
                }
            }
        }
    }

    static scrollTo(container, id){
        Registry.d("Registry.scrollTo");
        let toptop = $(`iframe[data-containerid='${container}']`).offset().top;
        let frametop = $(`iframe[data-containerid='${container}']`).contents().find(`#${id}`).offset().top;

        // If page has Menu widget with type Fixed-to Top or Sticky, then scrollTo below Menu widget
        let menuHeight = 0;
        let menuSelector = '.ipWidget-MenuWidget nav.navbar.navbar-type-';
        let menuWidgets = $(`${menuSelector}sticky, ${menuSelector}fixed-top`);
        if(menuWidgets.length > 0) {
            menuHeight = $(menuWidgets[0]).outerHeight();
            if ($(menuWidgets[0]).hasClass('navbar-type-sticky')) {
                let offsetOnLoad = $(menuWidgets[0]).offset().top;
                if ($(window).scrollTop() < offsetOnLoad) {
                    menuHeight += $(menuWidgets[0]).outerHeight();
                }
            }
        }

        return window.scrollTo(0, toptop+frametop-menuHeight);
    }

    static reload() {
        Registry.d("Registry.reload");
        return (() => {
            let result = [];
            for (let x of Array.from(top.__etouches.objs["Widget"])) {
                let item;
                if (x.display) {
                    item = x.display();
                }
                result.push(item);
            }
            return result;
        })();
    }
};






// WEBPACK FOOTER //
// ./src/embed/Registry.es6